module.exports = __webpack_public_path__ + "static/media/about-bg.e698a558.svg";